import { devicesServiceFilter } from "@pages/Dashboard/WidgetEdit/FilterPanel/constants";
import { MonitoringLevel } from "@services/devices/types";

export const getMonitoringLevelValue = (value: string) => {
  if (value === "Basic Monitoring" || value === "Advanced Monitoring") {
    const monitoringLevelValue = devicesServiceFilter.find(
      (x) => x.label === value
    );
    if (monitoringLevelValue)
      return monitoringLevelValue?.value as MonitoringLevel;
  }
  return value as MonitoringLevel;
};
